import { render, staticRenderFns } from "./ddtjbb.vue?vue&type=template&id=96dfb580&scoped=true"
import script from "./ddtjbb.vue?vue&type=script&lang=js"
export * from "./ddtjbb.vue?vue&type=script&lang=js"
import style0 from "./ddtjbb.vue?vue&type=style&index=0&id=96dfb580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dfb580",
  null
  
)

export default component.exports